
import { LockDec, ValidateDec } from '@/decorators';
import { Component, Vue, Watch } from 'vue-facing-decorator'
@Component({})
export default class extends Vue {
  @Watch('formData.goodsType')
  formDataGoodsType() {
    if (this.loading) return;
    this.formData.goodsList = [];
  }

  submitLoading = false

  loading = false

  defaultTime2 = [
    new Date(2000, 1, 1, 0, 0, 0),
    new Date(2000, 1, 1, 23, 59, 59),
  ]

  /** 优惠券类型，取值同后端 CouponEntity.type */
  typeList = [
    { name: "满减券", desc: "(满减金额)", value: 0 },
    { name: "折扣券", desc: "(按折优惠)", value: 1 },
    { name: "随机金额券", desc: "(区间随机)", value: 2 },
  ]

  formData = {
    id: undefined,
    name: "",
    type: 0,
    price: "",
    randMinPrice: "",
    randMaxPrice: "",
    discount: 0,
    hasDiscountLimit: false,
    discountMaxPrice: 0,
    remake: "",
    count: 0,
    goodsType: 0,
    goodsList: [],
    hasThreshold: false,
    thresholdValue: "",
    timeType: 0,
    timeValue: "",
    startTime: null,
    endTime: null,
    hasGetCountLimit: false,
    getCountValue: "",
    overlap: true,
    content: "",
  }

  get userTimeRange() {
    if (!this.formData.startTime && !this.formData.startTime) return [];
    return [this.formData.startTime, this.formData.endTime];
  }

  set userTimeRange(res) {
    if (!res) {
      this.formData.startTime = null;
      this.formData.endTime = null;
      return;
    }
    let [startTime, endTime] = res
    this.formData.startTime = startTime;
    this.formData.endTime = endTime;
  }

  async created() {
    this.loading = true;
    await this.getData();
    this.loading = false;
  }

  async getData() {
    let id = this.$route.query.id;
    if (!id) return;
    let { error, data } = await this.$post("/manager/coupon/detail", {
      id
    });
    if (error) return;
    this.formData = data;
  }

  /**
   * discount 是"折"，10 表示原价。后端 coupon.service 把 (0, 10) 之外的折扣
   * 当成没配折扣、按 0 抵扣处理，所以这里也卡开区间；
   * 勾了"最多优惠"必须给金额，后端 0 等于不封顶，会静默失效。
   */
  validateDiscount(v) {
    if (!v) throw "请输入折扣";
    let discount = Number(v);
    if (!(discount > 0) || discount >= 10) throw "折扣需在 0.01 ~ 9.99 之间";
    if (this.formData.hasDiscountLimit && !(Number(this.formData.discountMaxPrice) > 0)) {
      throw "请输入最多优惠金额";
    }
  }

  /** 随机金额券发券时按区间取随机数，min 大于 max 会取不出金额 */
  validateRandPrice(v) {
    let min = Number(v);
    if (!(min > 0)) throw "请输入随机最小金额";
    let max = Number(this.formData.randMaxPrice);
    if (!(max > 0)) throw "请输入随机最大金额";
    if (min > max) throw "随机最小金额不能大于最大金额";
  }


  @ValidateDec("form", {
    showTips: true
  })
  @LockDec("submitLoading")
  async submit() {
    await this.$postNotify("/manager/coupon/operat", {
      ...this.formData,
    });
    this.$router.back();
  }
}
